<style lang="less" scoped>
</style>

<template lang="pug">
  .empty empty
</template>

<script>
export default {
};
</script>
